import { CHECKOUT_STATE } from '../checkout/constants'
// @flow
export const ORDER_STATE = CHECKOUT_STATE

export const UPDATE_PERSONAL_INFO_RESOURCE = 'updatePersonalInfo'
export const UPDATE_PERSONAL_INFO_REQUEST = 'UPDATE_PERSONAL_INFO_REQUEST'
export const UPDATE_PERSONAL_INFO_SUCCESS = 'UPDATE_PERSONAL_INFO_SUCCESS'
export const UPDATE_PERSONAL_INFO_END_WITH_ERROR =
  'UPDATE_PERSONAL_INFO_END_WITH_ERROR'

export const UPDATE_PASSWORD_RESOURCE = 'updatePassword'
export const UPDATE_PASSWORD_REQUEST = 'UPDATE_PASSWORD_REQUEST'
export const UPDATE_PASSWORD_SUCCESS = 'UPDATE_PASSWORD_SUCCESS'
export const UPDATE_PASSWORD_END_WITH_ERROR = 'UPDATE_PASSWORD_END_WITH_ERROR'

export const CREATE_USER_ADDRESS_RESOURCE = 'createUserAddress'
export const CREATE_USER_ADDRESS_REQUEST = 'CREATE_USER_ADDRESS_REQUEST'
export const CREATE_USER_ADDRESS_SUCCESS = 'CREATE_USER_ADDRESS_SUCCESS'
export const CREATE_USER_ADDRESS_END_WITH_ERROR =
  'CREATE_USER_ADDRESS_END_WITH_ERROR'

export const UPDATE_USER_ADDRESS_RESOURCE = 'updateUserAddress'
export const UPDATE_USER_ADDRESS_REQUEST = 'UPDATE_USER_ADDRESS_REQUEST'
export const UPDATE_USER_ADDRESS_SUCCESS = 'UPDATE_USER_ADDRESS_SUCCESS'
export const UPDATE_USER_ADDRESS_END_WITH_ERROR =
  'UPDATE_USER_ADDRESS_END_WITH_ERROR'

export const DELETE_USER_ADDRESS_RESOURCE = 'deleteUserAddress'
export const DELETE_USER_ADDRESS_REQUEST = 'DELETE_USER_ADDRESS_REQUEST'
export const DELETE_USER_ADDRESS_SUCCESS = 'DELETE_USER_ADDRESS_SUCCESS'
export const DELETE_USER_ADDRESS_END_WITH_ERROR =
  'DELETE_USER_ADDRESS_END_WITH_ERROR'
export const DELETE_USER_ADDRESS_CONFIRM_MODAL = 'modal.deleteUserAddress'



// WEBPACK FOOTER //
// ./src/services/myprofile/constants.js